var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        ((_obj = {}),
        (_obj["checkbox-component"] = true),
        (_obj.line = _vm.isLine),
        (_obj.disable = _vm.isDisable),
        _obj)
    },
    [
      _c("label", { attrs: { for: _vm.prefixId + _vm.id } }),
      _c("input", {
        attrs: {
          type: "checkbox",
          id: _vm.prefixId + _vm.id,
          name: _vm.id,
          hidden: "hidden",
          disabled: _vm.isDisable
        },
        domProps: { checked: _vm.isChecked },
        on: { change: _vm.handleCheckboxChange }
      }),
      _c("div", { staticClass: "content-checkbox" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }